module.exports = __webpack_public_path__ + "static/2-34077c2ae4a023e25230a44ae5ecaa03.png";